import { urls } from './urls';

export default {
  searchPath: `${urls.root}/shop/search`,
  productImage: '//ecom-su-static-prod.wtrecom.com/images/products',
};
